import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Fuse from 'fuse.js';

import CheckingOffensesTable from '../components/CheckingOffensesTable';
import CheckingOffensesModel from '../components/CheckingOffensesModel';

import ParkinglocationSelect from '../components/ParkinglocationSelect';

import UserModel from '../components/UserModel'

import { Layout, Button, Row, Col, Input, Icon, message, DatePicker } from 'antd';

class CheckingOffensesScreen extends Component {

  fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      "plate"
    ]
  }

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    parkinglocation: null,
    dateFrom: moment().startOf('day'),
    dateTo: moment().endOf('day'),
    searchText: "",
    selectedItems: [],    
    selectedRowKeys: [],
    firstSelectedItem: null,
    reportLoading: false
  }

  componentWillMount() {
    this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
  }

  loadData(parkinglocation = null, dateFrom = null, dateTo = null, plate = null) {
    dateFrom = dateFrom ? dateFrom.format() : null;
    dateTo = dateTo ? dateTo.format() : null;
    this.setState({
      dataLoading: true,
      dataAll: [],
      data: []
    });
    CheckingOffensesModel.getAll(
      parkinglocation,
      dateFrom,
      dateTo
    )
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data,
          searchText: ""
        });
      })
      .catch(err => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      dataLoading: true
    })
    if (searchText) {
      let fuse = new Fuse(dataAll, this.fuseOptions);
      let results = fuse.search(searchText);
      results = results.map((result) => {
        return result.item;
      });
      this.setState({
        dataLoading: false,
        data: results
      });
    } else {
      this.setState({
        dataLoading: false,
        data: dataAll
      });
    }
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(this.state.parkinglocation, dates[0], dates[1]);
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Kontrola PO - Provedené kontroly</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={21}>
                <ParkinglocationSelect
                  onChange={(value) => {
                    this.setState({ parkinglocation: value });
                    this.loadData(value, this.state.dateFrom, this.state.dateTo);
                  }}
                  style={{ width: 300 }} />
                {' '}
                <DatePicker.RangePicker
                  defaultValue={[
                    this.state.dateFrom,
                    this.state.dateTo
                  ]}
                  ranges={{
                    "Dnes": [moment().startOf('day'), moment().endOf('day')],
                    "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                    "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                  }}
                  allowClear={false}
                  placeholder={['Od', 'Do']}
                  format="DD.MM.YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  onOk={this.onDateRangeChanged.bind(this)}
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Hledat RZ"
                  onChange={(e) => {
                    let text = e.target.value;
                    if (text === "") {
                      this.onSearch(text);
                    }
                    this.setState({
                      searchText: text
                    });
                  }}
                  onSearch={(searchText) => {
                    this.onSearch(searchText);
                  }}
                  value={this.state.searchText}
                  style={{ width: 300 }}
                  allowClear={true} />
                {' '}
                <Button
                  type="default"
                  onClick={() => {
                    this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
                    this.setState({ selectedItems: [], selectedRowKeys: [], firstSelectedItem: null });
                  }} >
                  <Icon type="sync" />
                </Button>
              </Col>
              <Col span={3} offset={0} style={{ textAlign: 'right' }}>
                {UserModel.isInRoles(['ADMIN', 'PPR_REPORTS_WRITE']) ?
                  <Button
                    type="primary"
                    disabled={this.state.selectedItems.length < 2}
                    loading={this.state.reportLoading}
                    onClick={() => {
                      this.setState({ reportLoading: true });
                      CheckingOffensesModel.reportToPPR(this.state.selectedItems)
                        .then(() => {
                          message.success('Přestupky byly předány do modulu PPŘ');
                          this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
                          this.setState({ reportLoading: false, selectedItems: [], selectedRowKeys: [], firstSelectedItem: null });
                        })
                        .catch(() => {
                          message.error('Přestupky se nepodařilo předat do modulu PPŘ!');
                          this.setState({ reportLoading: false });
                        });
                    }} >
                    Předat do PPŘ
                </Button>
                  : null}
              </Col>
            </Row>
          </div>
          <CheckingOffensesTable
            data={this.state.data}
            loading={this.state.dataLoading}
            selectedRowKeys={this.state.selectedRowKeys}
            firstSelectedItem={this.state.firstSelectedItem}
            onRowSelectionChanged={(selectedRowKeys, selectedRows) => {
              if (selectedRows.length > 0) {
                let item = {
                  plate: selectedRows[0].plate,
                  date: moment(selectedRows[0].timestamp)
                }
                this.setState({
                  firstSelectedItem: item,
                  selectedItems: selectedRows,
                  selectedRowKeys
                });
              } else {
                this.setState({
                  firstSelectedItem: null,
                  selectedItems: selectedRows,
                  selectedRowKeys
                });
              }
            }}
            onRemoveRow={(id) => {
              CheckingOffensesModel.remove(id)
                .then(() => {
                  this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
                });
            }}
            onGroupedBy={(row) => {
              this.setState({
                dataLoading: true,
              });
              CheckingOffensesModel.getAll(
                row.locationId,
                moment(row.timestamp).startOf('day').utc().format(),
                moment(row.timestamp).endOf('day').utc().format(),
                row.plate
              )
                .then((data) => {
                  this.setState({
                    dataLoading: false,
                    data: data,
                    searchText: row.plate
                  });
                })
                .catch(err => {
                  message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
                  this.setState({
                    dataLoading: false,
                  });
                });
              this.setState({
                searchText: row.plate
              });
            }}
            onAnyFormSuccess={() => {
              this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
            }} />
          <p style={{ fontSize: 12, fontStyle: 'italic' }}>
            <b>Probíhá kontrola</b> - zatím nejsou známy výsledky kontroly<br />
            <b>Částečná shoda</b> - shoda ve 4 koncových znacích detekované RZ<br />
            <b>Možný přestupek</b> - RZ ani její část nemá platné PO<br />
            <b>Seskupit</b> - Zobrazí záznamy pro RZ ve stejné lokalitě a v den vytvotření záznamu (datumový filtr a filtr lokality nebude použit)<br />
            Kliknutím na stav kontroly zobrazíte nalezená PO
          </p>
        </div>
      </Layout.Content>
    );
  }
}

export default CheckingOffensesScreen;



// WEBPACK FOOTER //
// ./src/screens/CheckingOffensesScreen.js